// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'walkie-solid';

export const Component = () => (
  <path d='M14.827 4.923V1.491a.49.49 0 1 1 .982 0v3.432h.98c1.084 0 1.962.879 1.962 1.962v14.712a1.962 1.962 0 0 1-1.962 1.962H8.943a1.962 1.962 0 0 1-1.962-1.962V6.885c0-1.083.878-1.962 1.962-1.962h5.884ZM9.923 6.885s-.98.44-.98.98v2.943c0 .541.439.98.98.98h5.885a.98.98 0 0 0 .98-.98V7.866a.98.98 0 0 0-.98-.98H9.923Zm1.472 7.846h2.942a.49.49 0 1 0 0-.981h-2.942a.49.49 0 1 0 0 .981Zm-1.472 1.961h5.885a.49.49 0 1 0 0-.981H9.923a.49.49 0 1 0 0 .981Zm0 1.962h5.885a.49.49 0 1 0 0-.981H9.923a.49.49 0 1 0 0 .98Zm1.472 1.962h2.942a.49.49 0 1 0 0-.982h-2.942a.49.49 0 1 0 0 .982ZM6.479 9.827h.501v2.943h-.5a.478.478 0 0 1-.48-.48v-1.984c0-.265.214-.479.479-.479Z' />
);

export const viewBox = '0 0 25 25';
